import React from "react";
import { useParams } from "react-router-dom";

const CONTENT = {
  terms: { title: "Όροι & Προϋποθέσεις", body: [
    "Καλωσήρθατε στο SKGWEAR. Χρησιμοποιώντας τον ιστότοπό μας αποδέχεστε τους παρόντες όρους χρήσης.",
    "Όλα τα προϊόντα υπόκεινται σε διαθεσιμότητα. Διατηρούμε το δικαίωμα να τροποποιήσουμε τιμές και προϊόντα χωρίς προειδοποίηση.",
    "Οι παραγγελίες επιβεβαιώνονται μετά την ολοκλήρωση της πληρωμής ή την καταχώρηση αντικαταβολής.",
    "Το περιεχόμενο του ιστότοπου (λογότυπα, σχέδια, κείμενα) αποτελεί πνευματική ιδιοκτησία της SKGWEAR.",
  ]},
  privacy: { title: "Πολιτική Απορρήτου", body: [
    "Η SKGWEAR σέβεται την ιδιωτικότητά σας. Συλλέγουμε μόνο τα απαραίτητα δεδομένα για την εκτέλεση των παραγγελιών σας.",
    "Τα προσωπικά σας δεδομένα (όνομα, διεύθυνση, email, τηλέφωνο) χρησιμοποιούνται αποκλειστικά για την επεξεργασία και αποστολή παραγγελιών.",
    "Δεν κοινοποιούμε τα δεδομένα σας σε τρίτους, εκτός των απαραίτητων συνεργατών αποστολής και πληρωμών (Stripe).",
    "Έχετε δικαίωμα πρόσβασης, διόρθωσης και διαγραφής των δεδομένων σας σύμφωνα με τον GDPR.",
  ]},
  cookies: { title: "Πολιτική Cookies", body: [
    "Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία πλοήγησης και τις λειτουργίες του καλαθιού.",
    "Τα απαραίτητα cookies διασφαλίζουν τη σωστή λειτουργία του ιστότοπου.",
    "Μπορείτε να διαχειριστείτε τις προτιμήσεις cookies από τις ρυθμίσεις του browser σας.",
  ]},
  shipping: { title: "Πολιτική Αποστολών", body: [
    "Αποστέλλουμε σε όλη την Ελλάδα. Standard παράδοση 2-4 εργάσιμες (€3.50), Express 1-2 εργάσιμες (€6.90).",
    "Δωρεάν μεταφορικά για παραγγελίες άνω των €80.",
    "Διαθέσιμη η επιλογή αντικαταβολής με επιπλέον χρέωση €2.",
    "Θα λάβετε email με τον αριθμό παρακολούθησης μόλις αποσταλεί η παραγγελία σας.",
  ]},
  returns: { title: "Επιστροφές & Επιστροφή Χρημάτων", body: [
    "Έχετε 14 ημέρες από την παραλαβή για να επιστρέψετε ένα προϊόν.",
    "Τα προϊόντα πρέπει να είναι αφόρετα, με τις ετικέτες τους και στην αρχική συσκευασία.",
    "Η επιστροφή χρημάτων γίνεται εντός 5-10 εργάσιμων ημερών μετά την παραλαβή του προϊόντος.",
    "Για να ξεκινήσετε μια επιστροφή, επικοινωνήστε μαζί μας με τον αριθμό παραγγελίας σας.",
  ]},
};

export default function LegalPage() {
  const { page } = useParams();
  const c = CONTENT[page] || CONTENT.terms;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#FF2E4C] mb-2">ΝΟΜΙΚΑ</p>
      <h1 className="font-display text-3xl sm:text-4xl font-black uppercase tracking-tighter mb-8">{c.title}</h1>
      <div className="space-y-4 text-zinc-300 leading-relaxed">
        {c.body.map((p, i) => <p key={i}>{p}</p>)}
      </div>
      <p className="text-xs text-zinc-600 mt-10 font-mono">Τελευταία ενημέρωση: {new Date().toLocaleDateString("el-GR")} · SKGWEAR · Θεσσαλονίκη</p>
    </div>
  );
}
